export const analyticsEvents = {
  TRACK_CONTENT_ELEMENT: 'content_element_pressed',
  TRACK_CREATE_JOB: 'create_a_job_ad_pressed',
  TRACK_TALENT_SEARCH: 'talent_search_pressed',
  TRACK_CONTINUE_DRAFT: 'continue_draft_pressed',
  TRACK_JOB_TITLE: 'job_title_pressed',
  TRACK_VIEW_CANDIDATES_COUNT: 'candidate_count_pressed',
  TRACK_VIEW_APPLICANTS: 'see_applicants_pressed',
  TRACK_AD_HEALTH: 'ad_health_metrics_pressed',
  TRACK_COPY_JOB: 'copy_job_pressed',
  TRACK_EDIT_JOB: 'edit_job_pressed',
  TRACK_REFRESH_JOB: 'refresh_job_pressed',
  TRACK_UPGRADE_JOB_CTA: 'job_upgrade_button_pressed',
  TRACK_VIEW_JOB: 'view_job_pressed',
  TRACK_VIEW_ALL_JOBS: 'view_all_job_ads_pressed',
  TRACK_MORE_OPTIONS: 'more_job_options_pressed',
  TRACK_COMPANY_PROFILE_BANNER_LINK: 'company_profile_banner_link_pressed',
  TRACK_NUDGE_VIEWED: 'nudge_viewed',
  TRACK_NUDGE_PRESSED: 'nudge_pressed',
  TRACK_NUDGE_DISSMISSED: 'nudge_dismissed_pressed',
  TRACK_FIND_RECRUITER_PRESSED: 'pay_per_hire_pressed',
  TRACK_FIND_RECRUITER_VIEWED: 'pay_per_hire_viewed',
  TRACK_DIALOG_DISMISSED: 'alert_dismiss_pressed',
  TRACK_VIEW_DIALOG: 'alert_viewed',
};
